"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSortDirShort = void 0;
exports.mapColumnsSettingsToStrings = mapColumnsSettingsToStrings;
exports.parseColumnsSettingsStrings = parseColumnsSettingsStrings;
exports.parseSorting = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get = _interopRequireDefault(require("lodash/fp/get"));

var _isFinite = _interopRequireDefault(require("lodash/fp/isFinite"));

var _SortUtils = require("./SortUtils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getSortDirShort = function getSortDirShort(sortDir) {
  return sortDir === _SortUtils.SortDirection.DESCENDING ? '-' : '+';
};

exports.getSortDirShort = getSortDirShort;

var parseSorting = function parseSorting(sortValueShort) {
  var sortDir = sortValueShort.startsWith('-') ? _SortUtils.SortDirection.DESCENDING : _SortUtils.SortDirection.ASCENDING; // Note: due to a bug in qs 6.7.0 the '+' sorting will be parsed as a space by qs even though decoding is disabled
  // therefore, we need to trim the value

  return {
    sortBy: sortValueShort.replace(/^[+-]/, '').trim(),
    sortDir: sortDir
  };
};

exports.parseSorting = parseSorting;

function mapColumnsSettingsToStrings(_ref) {
  var _ref$columnOrder = _ref.columnOrder,
      columnOrder = _ref$columnOrder === void 0 ? [] : _ref$columnOrder,
      _ref$hiddenColumns = _ref.hiddenColumns,
      hiddenColumns = _ref$hiddenColumns === void 0 ? [] : _ref$hiddenColumns,
      _ref$columnsDetails = _ref.columnsDetails,
      columnsDetails = _ref$columnsDetails === void 0 ? {} : _ref$columnsDetails;
  var mappedColumns = columnOrder.map(function (column) {
    var currentWidth = (0, _get.default)('width')(columnsDetails[column]);
    var defaultWidth = (0, _get.default)('defaultWidth')(columnsDetails[column]);
    var width = currentWidth !== 0 && currentWidth !== defaultWidth ? ":".concat(currentWidth) : '';
    var hiddenSign = hiddenColumns.includes(column) ? '-' : '';
    return "".concat(hiddenSign).concat(column).concat(width);
  });
  return mappedColumns;
}

function parseColumnsSettingsStrings() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultColumnsDetails = arguments.length > 1 ? arguments[1] : undefined;
  var columns = {
    columnOrder: [],
    hiddenColumns: [],
    columnsDetails: _objectSpread({}, defaultColumnsDetails)
  };
  settings.map(function (setting) {
    var _setting$split = setting.split(':'),
        _setting$split2 = (0, _slicedToArray2.default)(_setting$split, 2),
        column = _setting$split2[0],
        columnWidth = _setting$split2[1];

    var columnKey = column.startsWith('-') ? column.substr(1) : column;
    columns.columnOrder = [].concat((0, _toConsumableArray2.default)(columns.columnOrder), [columnKey]);

    if (columnWidth) {
      var width = parseInt(columnWidth, 10);

      if ((0, _isFinite.default)(width)) {
        columns.columnsDetails[columnKey] = _objectSpread(_objectSpread({}, columns.columnsDetails[columnKey]), {}, {
          width: width
        });
      }
    } else {
      columns.columnsDetails[columnKey] = _objectSpread({}, defaultColumnsDetails[columnKey]);
    }

    if (column.startsWith('-')) {
      columns.hiddenColumns = [].concat((0, _toConsumableArray2.default)(columns.hiddenColumns), [columnKey]);
    }
  });
  return columns;
}